<template>
  <div class="home">
    <!---categories--->
    <div class="categories">
      <div class="container">
        <Widget position="home_targets"/>
      </div>
    </div>

    <!---carousel--->
    <div class="about-us">
      <div class="container">
        <Widget position="main_content"/>
      </div>
    </div>
    <div id="advertisement" class="advertisement">
      <Widget position="advertisement"/>
    </div>
  </div>
</template>

<script>
  import Widget from '@/components/app/Widget'

  export default {
    name: 'home',
    components: {
      Widget
    }
  }
</script>
